import { render, staticRenderFns } from "./SearchIndexContent.vue?vue&type=template&id=5a82fde9&"
import script from "./SearchIndexContent.vue?vue&type=script&lang=js&"
export * from "./SearchIndexContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports